import React from "react";
import Card from "antd/lib/card/Card";
const PublicPage = () => {
  return (
    <div className="ihub-public-main">
      <center>
        <Card
          title="Integrations Hub by Rixter AB"
          bordered={false}
          style={{ width: 300 }}
        >
          <img src="https://marketplace-cdn.atlassian.com/files/e3fc3518-fbbd-42c1-9f1e-b142787d8492?fileType=image&mode=full-fit"></img>
          <p>
            Quickly connect Jira across any system using REST, SOAP. Reduces
            cost and complexity for Jira integrations
          </p>
          <p>
            iHub can Import any Jira Service Management Assets from external
            sources
          </p>
          <a href="https://marketplace.atlassian.com/vendors/1214651">
            Rixter Apps
          </a>
          <p>Cloud Security Participant</p>
        </Card>
      </center>
    </div>
  );
};
export default PublicPage;
